import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import clientService from "../services/clientService";
import invoiceService from "../services/invoiceService";
import { filter } from "lodash";
const initialState = {
    invoices: [],
    lastSavedInvoice: null,
    loading: false,
    error: null,
    invoiceNumber: null,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 6, // Size of each page
    totalAmountTtc: 0,
    totalAmountHt: 0,// Add this field
    dateFrom: null,
    dateTo: null,
    currentInvoice: null,
    canBeUpdated: false,

};

const invoiceSlice = createModule({
    name: 'invoices',
    initialState,
    reducers: {
        generatePdfRequest: (state) => {
            state.loading = true;
        },
        list: (state) => {
            state.loading = true;
        },
        listWithSubInvoices: (state) => {
            state.loading = true;
        },
        filterInvoice: (state, action) => {
            state.loading = true;
        },
        addInvoice: (state) => {
            state.loading = true;
        },
        addPayment: (state) => {
            state.loading = true;
        },
        deleteInvoice: (state) => {
            state.loading = true;
        },
        lastSaved: (state) => {
            state.loading = true;
        },
        fetchNewInvoiceNumber: (state) => {
            state.loading = true;
        },
        fetchedData: (state, payload) => {
            state.loading = false;
            state.invoices = payload.body;
        },
        fetchedDataWithSubInvoices: (state, action) => {
            state.loading = false;
            state.invoices = action.invoices || [];
            state.subInvoices = action.subInvoices || [];
            state.totalElements = action.totalElements || 0;
            state.totalPages = action.totalPages || 0;
            state.pageNumber = action.pageNumber || 0;
            state.pageSize = action.pageSize || 6;
            state.totalAmountTtc = action.totalAmountTtc || 0;
            state.totalAmountHt = action.totalAmountHt || 0;
        },
        fetchedInvoiceNumber: (state, action) => {
            state.loading = false;
            state.invoiceNumber = action;
        },
        finishFetching: (state) => {
            state.loading = false;
        },
        fetchError: (state, action) => {
            state.loading = false;
            state.error = action.payload || "An error occurred";
        },
        generatePdfSuccess: (state) => {
            state.loading = false;
        },
        generatePdfFailure: (state, action) => {
            state.loading = false;
            state.error = action;
        },
        deleteInvoiceSuccess: (state, action) => {
            state.loading = false;
            state.invoices = state.invoices.filter(invoice => invoice.id !== action.id);
        },
        deleteInvoiceFailure: (state, action) => {
            state.loading = false;
            state.error = action;
        },
        updateInvoiceRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        updateInvoiceSuccess: (state, action) => {
            state.loading = false;
        },
        updateInvoiceFailure: (state, action) => {
            state.loading = false;
            state.error = action;
        },

        cancelInvoiceRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        
        cancelInvoiceSuccess: (state, action) => {
            state.loading = false;
        },

        cancelInvoiceFailure: (state, action) => {
            state.loading = false;
            state.error = action;
        },
        
        checkCanUpdateRequest: (state) => {
            state.loading = true;
        },
        
        checkCanUpdateSuccess: (state, action) => {
            state.loading = false;
            state.canBeUpdated = action;
        },
        
        checkCanUpdateFailure: (state, action) => {
            state.loading = false;
            state.error = action;
        },
        
        getInvoiceByIdRequest: (state) => {
            state.loading = true;
            state.error = null;
        },
        
        getInvoiceByIdSuccess: (state, action) => {
            state.loading = false;
            state.currentInvoice = action.payload;
        },
        
        getInvoiceByIdFailure: (state, action) => {
            state.loading = false;
            state.error = action;
        },

        clearCurrentInvoice: (state) => {
            state.currentInvoice = null;
            state.canBeUpdated = false;
        },

    },
    sagas: (A) => ({
        *[A.list]({ payload }) {
            try {
                console.log(payload);
                const data = yield call(invoiceService.list, {query: payload.query});
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.listWithSubInvoices]({ payload }) {
            try {
                
                const response = yield call(invoiceService.listWithSubInvoices, payload);
                                
                // Extract data from response
                const data = response.data || response;
                
                // Structure the response data
                const structuredData = {
                    invoices: data.body || data.invoices || [],
                    subInvoices: data.subInvoices || [],
                    totalElements: data.totalElements || 0,
                    totalPages: data.totalPages || 0,
                    pageNumber: data.number || data.pageNumber || 0,
                    pageSize: data.size || data.pageSize || 6,
                    totalAmountTtc: data.totalAmountTtc || 0,
                    totalAmountHt: data.totalAmountHt || 0
                };
                
                yield put(A.fetchedDataWithSubInvoices(structuredData));
                
                // Call success callback if provided
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, structuredData);
                }
                
            } catch (e) {
                console.error('Error fetching invoices with sub-invoices:', e);
                yield put(A.fetchError(e.message || 'Error fetching invoices with sub-invoices'));
                
                // Call error callback if provided
                if (payload.onError) {
                    yield call(payload.onError, e);
                }
            }
        },
        *[A.filterInvoice]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(invoiceService.filterInvoice, payload);
                yield put(A.finishFetching());
                yield put(A.fetchedData(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.addInvoice]({ payload }) {
            try {
                const data = yield call(invoiceService.addInvoice, payload.invoice);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
                // yield put(A.generatePdfRequest(data.data.body)); // Dispatch the action to generate the PDF after invoice creation
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
        *[A.addPayment]({ payload }) {
            try {
                console.log(payload);
                const { data } = yield call(invoiceService.addPayment, payload.data);
                yield put(A.finishFetching());
                yield call(payload.onSuccess, data);
            } catch (e) {
                yield put(A.finishFetching());
                yield call(payload.onError());
                yield put(A.fetchError());
            }
        },
        *[A.generatePdfRequest]({ payload }) {
            try {
                const pdfData = yield call(invoiceService.generatePdf, payload);
                const blob = new Blob([pdfData], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank'); // Open the PDF in a new window
                yield put(A.generatePdfSuccess());
            } catch (error) {
                yield put(A.generatePdfFailure(error.message));
            }
        },
        *[A.deleteInvoice]({ payload }) {
            try {
                yield call(invoiceService.deleteInvoice, payload.id);
                yield put(A.deleteInvoiceSuccess(payload));
                payload.onSuccess();
            } catch (e) {
                console.log(e);
                yield put(A.deleteInvoiceFailure(e.message));
            }
        },
        *[A.lastSaved]({ payload }) {
            try {
                const { data } = yield call(invoiceService.getLastSavedInvoice);
                yield put(A.fetchedData(data));
                payload.onSuccess(data);

            } catch (e) {
                console.log(e);
                yield put(A.fetchError(e.message));
            }
        },
        *[A.updateInvoiceRequest]({ payload }) {
            try {
                const data = yield call(invoiceService.updateInvoice, payload.id, payload.invoiceData);
                yield put(A.updateInvoiceSuccess(data));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess);
                }
            } catch (error) {
                yield put(A.updateInvoiceFailure(error.response?.data?.error || error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },
        
        *[A.cancelInvoiceRequest]({ payload }) {
            try {
                yield call(invoiceService.cancelInvoice, payload.id, payload.motifAnnulation);
                yield put(A.cancelInvoiceSuccess({ id: payload.id }));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess);
                }
            } catch (error) {
                yield put(A.cancelInvoiceFailure(error.response?.data?.error || error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },
        
        *[A.checkCanUpdateRequest]({ payload }) {
            try {
                const data = yield call(invoiceService.canBeUpdated, payload.id);
                yield put(A.checkCanUpdateSuccess(data));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                yield put(A.checkCanUpdateFailure(error.response?.data?.error || error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },
        
        *[A.getInvoiceByIdRequest]({ payload }) {
            try {
                const data = yield call(invoiceService.getInvoiceById, payload.id);
                yield put(A.getInvoiceByIdSuccess(data));
                if (payload.onSuccess) {
                    yield call(payload.onSuccess, data);
                }
            } catch (error) {
                yield put(A.getInvoiceByIdFailure(error.response?.data?.error || error.message));
                if (payload.onError) {
                    yield call(payload.onError, error);
                }
            }
        },
        *[A.fetchNewInvoiceNumber]() {
            try {
                const { data } = yield call(invoiceService.getNewInvoiceNumber);
                yield put(A.fetchedInvoiceNumber(data));
            } catch (e) {
                console.log(e);
                yield put(A.finishFetching());
                yield put(A.fetchError());
            }
        },
    }),

});

export default invoiceSlice;
export const invoiceActions = invoiceSlice.actions;